import React from 'react';
import { Navigate } from 'react-router-dom';
import { Lock } from 'lucide-react';

const ROLE_LEVEL: Record<string, number> = { Administrator: 1, Superuser: 2, User: 3 };

interface Props {
  children: React.ReactNode;
  minRole?: 'User' | 'Superuser' | 'Administrator';
}

export const ProtectedRoute: React.FC<Props> = ({ children, minRole = 'User' }) => {
  const token = sessionStorage.getItem('iad2_token');
  if (!token) return <Navigate to="/login" replace />;

  if (minRole !== 'User') {
    try {
      const user = JSON.parse(sessionStorage.getItem('iad2_user') || '{}');
      const userLevel = ROLE_LEVEL[user.role] ?? 3;
      const requiredLevel = ROLE_LEVEL[minRole];
      if (userLevel > requiredLevel) {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100vh',
              gap: 12,
              color: 'var(--gray-500)',
            }}
          >
            <Lock size={32} />
            <h2 style={{ fontSize: 18, fontWeight: 900, margin: 0 }}>
              Access Restricted
            </h2>
            <p style={{ margin: 0 }}>You don&apos;t have permission to view this page.</p>
            <p style={{ fontSize: 12, margin: 0 }}>Contact your administrator for access.</p>
          </div>
        );
      }
    } catch {
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
};
